var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53541 6.50626V9.25726H11.4594C11.2194 10.1039 10.7034 10.8455 9.98941 11.3639C9.28141 11.8823 8.41741 12.1475 7.53541 12.1169C6.83341 12.1175 6.14341 11.9483 5.52541 11.6249C4.90741 11.3009 4.37341 10.8317 3.97141 10.2575C3.56941 9.68266 3.31741 9.02026 3.22741 8.32546C3.13741 7.63126 3.21541 6.92506 3.46141 6.26866C3.70141 5.61166 4.10341 5.02366 4.61941 4.55386C5.14141 4.08406 5.76541 3.74686 6.44341 3.57046C7.12141 3.39466 7.82941 3.38506 8.51341 3.54286C9.19741 3.70066 9.82741 4.02106 10.3614 4.47706L12.3834 2.45086C11.5194 1.66306 10.4754 1.09786 9.34741 0.804463C8.21341 0.511063 7.02541 0.497863 5.88541 0.766063C4.75141 1.03426 3.69541 1.57546 2.81341 2.34346C1.93141 3.11146 1.24741 4.08286 0.821409 5.17366C0.40141 6.26446 0.251409 7.44226 0.383409 8.60386C0.521409 9.76606 0.935409 10.8779 1.59541 11.8427C2.26141 12.8081 3.14341 13.5971 4.18141 14.1431C5.21341 14.6885 6.36541 14.9741 7.53541 14.9741C13.5834 14.9741 14.9154 9.32206 14.3214 6.51406L7.53541 6.50626Z",
    fill: "#5C5655"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/G.1f5bd838.svg";
export { ForwardRef as ReactComponent };